__turbopack_context__.v({
  "container": "ProductLineCarousel-module-scss-module__kwaZ-G__container",
  "swiper": "ProductLineCarousel-module-scss-module__kwaZ-G__swiper",
  "swiperSlide": "ProductLineCarousel-module-scss-module__kwaZ-G__swiperSlide",
  "titleContainer": "ProductLineCarousel-module-scss-module__kwaZ-G__titleContainer",
});
